import {inject, Injectable} from "@angular/core";
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree} from "@angular/router";
import {JwtHelperService} from "@auth0/angular-jwt";
import {SecurityService} from "@core/services";
import {Observable} from "rxjs";
import { profileStore } from "@core/store";

@Injectable({
  providedIn: 'root'
})
class PermissionsService {
    private store = inject(profileStore);

  constructor( private securityService: SecurityService,
               private route: Router) {}



  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.store.data.token.value()) {
      this.route.navigate(['']).then(r => {});
      return false;
    }

    return true;
  }

}

export const NotAuthGuard: CanActivateFn = (next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean => {
  return inject(PermissionsService).canActivate(next, state);
}
